<template>
	<div class="comment-item">
		<div class="item-l">
			<img :src="item.headPic?item.headPic:require('@/assets/default-avatar.png')"/>
			<div class="item-info">
				<div class="username">{{item.addUserName}}</div>
				<div class="comment-cnt">{{item.title}}{{item.content}}</div>
			</div>
		</div>
		<div class="item-r text-opacity">
			<div class="item-title" v-if="item.remark">{{item.remark}}</div>
			<div class="comment-type" v-if="item.templateType == 'SYSTEM'">{{item.templateSysType | getTypeValue}}</div>
			<div class="comment-time">{{item.addTime | datefmt('yyyy-MM-DD')}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'commentItem',
		components: {},
		data() {
			return {

			}
		},
		props: {
			item: {
				type: Object,
				value: ''
			}
		},
		filters: {
			getTypeValue (val) {
				if(val == 'SYSTEM') {
					return '系统消息'
				}
				if(val == 'POST_AUDIT') {
					return '帖子审核通过'
				}
				if(val == 'POST_BEST') {
					return '帖子加入精华'
				}
			}
		},
		methods: {

		}
	}
</script>

<style scoped lang="less">
	.comment-item{
		display: flex;
		justify-content: space-between;
		padding: 15px 0;
		border-bottom: 1px solid var(--color-border);
		.item-l{
			flex: 1;
			display: flex;
			margin-right: 10px;
			font-size: 16px;
			line-height: 24px;
			img{
				width: 48px;
				height: 48px;
				border-radius: 50%;
				margin-right: 10px;
			}
			.username{
				font-weight: bold;
			}
			.comment-cnt{
				margin-top: 4px;
				-webkit-line-clamp: 2;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				overflow: hidden;
				color:var(--color-text-opacity);
				line-height: 22px;
				word-break: break-word;
				overflow-wrap: anywhere;
			}
		}
		.item-r{
			width: 140px;
			display: flex;
			flex-direction: column;
			justify-content: space-between; 
			.item-title{
				margin: 2px 0 8px;
				-webkit-line-clamp: 2;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				overflow: hidden;
				word-break: break-word;
				overflow-wrap: anywhere;
			}
			.comment-time{
			}
		}
	}
	.comment-type{
		height:22px;
		padding:0 20px;
		margin-right: 20px;
		box-sizing: border-box;
		background: #cccccc;
		color: #898a8a;
		border-radius: 10px;
		line-height: 22px;
		text-align: center;
	}
</style>